import React from 'react';
import classNames from 'classnames';
import Formatters from '../../shared/utils/Formatters';
import PropTypes from 'prop-types';

import { includes } from "lodash";
import { currentDateDiffStatus } from '../../shared/utils/PaymentStatus';
import Loading from "../../shared/components/misc/Loading";

const UpcomingPaymentItem = ({ payment, loading, key }) => {
  if (loading) return <Loading />;

  function getClasses() {
    const copyStatus = currentDateDiffStatus(payment)
    const warningStats = ["Due Soon", "Due Today", "Pending"];
    const statClass = includes(warningStats, copyStatus) ? '-warning' : '';
    const statBg = includes(warningStats, copyStatus) ? '-bgWarningLight' : '';
    return(
      {
        iconClass: classNames('materialIcon', '--xxsmall', statClass),
        statusClass: classNames('ds-status', statClass),
        backgroundClass: classNames(statBg)
      }
    );
  }

  const { iconClass, statusClass, backgroundClass } = getClasses();
  const { due_date, payment: repayment } = payment;
  const { total } = repayment;

  return (
    <li key={key} className={backgroundClass} data-testid='upcoming-payment-item'>
      <div className="_displayFlex _justifyContent-space-between">
        <div className="_displayFlex _justifyContent-flex-start _alignItems-center">
          <i className={iconClass} data-testid='fiber-manual-icon'>
            fiber_manual_record
          </i>
          <p className="_fontSize--small-mobileOnly _marginRight--small -darkBlue" data-testid='payment-due-date'><strong>{Formatters.date(due_date)}</strong></p>
          <p className={statusClass} data-testid='payment-date-diff-stat'>{currentDateDiffStatus(payment).toUpperCase()}</p>
        </div>
        <div className="_displayFlex _justifyContent-flex-end _alignItems-center">
          <p className="_fontSize--small-mobileOnly -darkBlue" data-testid='payment-amount'>
            <strong>{Formatters.currency({ amount: total })}</strong>
          </p>
        </div>
      </div>
    </li>
  );
}

UpcomingPaymentItem.propTypes = {
  payment: PropTypes.shape({
    loan_plan_id: PropTypes.number,
    due_date: PropTypes.string,
    updated_date: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
    clearance: PropTypes.string,
    payment: PropTypes.shape({
      fee: PropTypes.number,
      interest: PropTypes.number,
      principal: PropTypes.number,
      total: PropTypes.number,
    }),
    status: PropTypes.string,
  }),
  loading: PropTypes.bool,
  key: PropTypes.number
}

export default UpcomingPaymentItem;



// WEBPACK FOOTER //
// ./src/features/home/components/UpcomingPaymentItem.js